import React from "react";
import { StyleSheet, Platform, ViewStyle, StyleProp } from "react-native";
import Animated, { AnimatedStyle } from "react-native-reanimated";
import MaskedView from "@react-native-masked-view/masked-view";
import { LinearGradient } from "expo-linear-gradient";
import { BlurView as ExpoBlurView } from "expo-blur";
import { LinearGradientConfig } from "../configs/linear-gradients";

const BUTTON_BACKGROUND_BLUR_CONFIG = {
    0: "rgba(255,255,255,0)",
    0.2: "rgba(255,255,255,0.8)",
    0.8: "rgba(255,255,255,1)",
    1: "rgba(255,255,255,1)",
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const {
    locations: BUTTON_BACKGROUND_BLUR_LOCATIONS,
    colors: BUTTON_BACKGROUND_BLUR_COLORS,
}: LinearGradientConfig = Object.keys(BUTTON_BACKGROUND_BLUR_CONFIG)
    .sort((a, b) => Number(a) - Number(b))
    .reduce(
        (result, key) => ({
            locations: [...result.locations, Number(key)],
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            colors: [...result.colors, BUTTON_BACKGROUND_BLUR_CONFIG[key]],
        }),
        {
            locations: [] as number[],
            colors: [] as string[],
        },
    );

type BackgroundBlurProps = {
    style?: AnimatedStyle<StyleProp<ViewStyle>>;
};

export const BackgroundBlur = ({ style }: BackgroundBlurProps) => {
    return (
        <Animated.View style={[StyleSheet.absoluteFill, style]}>
            {Platform.OS === "ios" ? (
                <MaskedView
                    maskElement={
                        <LinearGradient
                            locations={BUTTON_BACKGROUND_BLUR_LOCATIONS}
                            colors={BUTTON_BACKGROUND_BLUR_COLORS}
                            style={StyleSheet.absoluteFill}
                        />
                    }
                    style={StyleSheet.absoluteFill}
                >
                    <ExpoBlurView intensity={10} style={StyleSheet.absoluteFill} />
                </MaskedView>
            ) : (
                <LinearGradient
                    locations={BUTTON_BACKGROUND_BLUR_LOCATIONS}
                    colors={BUTTON_BACKGROUND_BLUR_COLORS}
                    style={[StyleSheet.absoluteFill, { opacity: 0.8 }]}
                />
            )}
        </Animated.View>
    );
};
